import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-publish-before-close-dialog',
  templateUrl: './publish-before-close-dialog.component.html',
  styleUrls: ['./publish-before-close-dialog.component.scss'],
  imports: [MatButtonModule, MatDialogActions, MatDialogTitle, MatDialogContent, TranslatePipe]
})
export class PublishBeforeCloseDialogComponent {
  constructor(public dialogRef: MatDialogRef<PublishBeforeCloseDialogComponent>) {}

  onPublishClose(): void {
    this.dialogRef.close('publish');
  }

  onDiscardClose(): void {
    this.dialogRef.close('discard');
  }

  onCancelContinue(): void {
    this.dialogRef.close('cancel');
  }
}
